/** 自定义单页 */
export default [
    {
        path: 'single/index',
        name: 'single-index',
        meta: {
            title: '自定义单页',
        },
        component: () => import('@/views/single/index.vue')
    },

]